import React from 'react';
import '../styles/About.css';

function About() {
  return (
    <div className="About">
      <h1>Sobre mim</h1>
      <h2>
        Sou engenheiro agrônomo apaixonado por tecnologia e estou em uma
        empolgante transição de carreira para o desenvolvimento web. Com uma
        sólida formação, estou animado em trazer minhas habilidades analíticas e
        capacidade de resolver problemas para o mundo da programação.
        <br />
        <br />
        Ao longo dos anos, trabalhei em diferentes projetos, e me especializei
        em engenharia de avaliações. Através dessas experiências, desenvolvi uma
        forte ética de trabalho, habilidades de liderança, gestão de tempo,
        comunicação, responsabilidade e uma abordagem orientada para resultados.
        No entanto, minha paixão pela tecnologia e pelo desenvolvimento web tem
        crescido gradualmente, e percebi que quero aplicar meus conhecimentos e
        habilidades em um campo que está em constante evolução.
        <br />
        <br />
        Para seguir meu objetivo, dediquei-me a aprender habilidades de
        programação, participando de cursos e projetos práticos. Adquiri
        conhecimentos em HTML, CSS, JavaScript, TypeScript, Python, React.js,
        Redux, Context API, Node.js, Docker, MySQL, Express, Sequelize, MongoDB,
        Mongoose, POO, arquiteturas MSC e SOLID, bem como soft-skills e
        metodologias ágeis. Estou sempre buscando aprender novas tecnologias
        para oferecer soluções inovadoras e eficientes.
        <br />
        <br />
        Minha transição para o desenvolvimento web é motivada pela oportunidade
        de unir meu conhecimento em ciências agrárias com a tecnologia, buscando
        impulsionar o setor agrícola para enfrentar os desafios globais, como a
        segurança alimentar e a sustentabilidade ambiental. Tenho o objetivo de
        criar aplicações e soluções digitais que ajudem a otimizar processos
        agrícolas, melhorar a eficiência produtiva e contribuir para um futuro
        mais sustentável.
        <br />
        <br />
        Estou animado em me conectar com profissionais da área de tecnologia,
        desenvolvimento web e agronomia para compartilhar experiências, aprender
        com suas trajetórias e explorar possíveis colaborações. Se você está
        interessado em inovação, agricultura sustentável ou desenvolvimento web,
        adoraria iniciar uma conversa e trocar ideias. Vamos conectar e juntos
        fazer a diferença!
      </h2>
    </div>
  );
}

export default About;
